import React, { useState } from "react"
import LoadingPage from "../reusableComponents/loader/loadingPage";
import { toast } from "react-toastify";
import { REACT_APP_VAM_ENDPOINT, REACT_APP_VAM_CONTEXT_GIS} from "../urls";
import { axiosRequest } from "../service";

const GisSurveyRequest = (props) => {
  const { claimID, getClaimDetails, gisSurveyList, claimDetailCookie,roleDataCookie } = props
  const [showGisSurveyModel, setShowGisSurveyModel] = useState(false)
  const [reason, setReason] = useState("")
  const [confirmFirstScreen, setConfirmFirstScreen] = useState(false)
  const [loadingGisRequest, setLoadingGisRequest] = useState(false)


  const makeGisSurveyRequest = () => {
    if(!reason){
        toast.error("Please Provide Reason");
        return;
      }
      setLoadingGisRequest(true)
      axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_GIS}/notifyGISSurvey`, {Claim_Number: claimID, "CMS_Comments": reason,"CreatedBy": roleDataCookie.userID,}).then(data => {
        setShowGisSurveyModel(false)
        gisSurveyList()
        getClaimDetails(claimID,false)
        toast.success(data.data.responseInformation.responseMessage)
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        setLoadingGisRequest(false)
      })
  }
 
  return (
    <>
      <div onClick={() => { if(claimDetailCookie.assignedTo === "Unassigned" || !claimDetailCookie.assignedTo){
                            toast.error("Please Assign Claims Handler.")
                            return
                        }setShowGisSurveyModel(true)}} className="requestCalc">Request GIS Survey</div>
      {
      showGisSurveyModel && 
      <div id="overlay1GIS">
        {
            loadingGisRequest ? <LoadingPage/> : <>
                <div className = "overlay_textCalc text-right me-3"><span type="button" onClick={() => setShowGisSurveyModel(false)} className="close" aria-label="Close">
                <span aria-hidden="true">&times;</span></span></div>
                <div className = "overlay-confirmationGIS">Are you sure you want a reconsideration or some more info regarding the current GIS Report?</div>
                <div className = "submit-1GIS" onClick={() => setConfirmFirstScreen(true)}>Yes</div>
                <div className = "backGIS" onClick={() => setShowGisSurveyModel(false)}>Back</div>
                {
                confirmFirstScreen && (
                    <div id = "overlay2GIS">
                        <div className = "overlay_textCalc text-right me-3"><span type="button" onClick={() => setShowGisSurveyModel(false)} className="close" aria-label="Close">
                        <span aria-hidden="true">&times;</span></span></div>
                        <div className = "overlay_textGIS">Reason <span onclick="off2()" className = "xGIS glyphicon glyphicon-remove"></span></div>
                        <div className = "overlay-conf-reasonGIS">Please provide the reason</div>
                        <div><textarea type = "textGIS" id = "reasonGIS" value={reason} onChange={(e) => setReason(e.target.value)}></textarea></div>
                        <div className = "submit-2GIS" onClick={() => makeGisSurveyRequest()}>Submit</div>
                    </div>
                )
                }           
            </>
        }
    </div>}
    </>
  )
};

export default GisSurveyRequest;